import React from 'react'

export default function CallToAction(props) {
  return (
    <a href="/kontakt" class="rounded-full uppercase bg-green-600 px-5 py-2 font-bold text-white">
      { props.text }
    </a>
  )
}
